<template>
  <div class="signInSheetVue">
        <div class="o-main-content-area o-main-content-area--padBotoomNone u-cmn-botmargin">
            <div class="c-responsive-fixwidth">
                <div class="row u-cmn-botmargin">
                    <div class="col-md-9">
                        <p class="u-back"><a href="javascript: void(0)" @click="backTojobDetails()"><i class="fa fa-chevron-left"></i> Back</a></p>

                    </div>
                    <div class="col-md-3 text-right">
                        <ul class="o-filter-area">

                            <li class="o-search-field">
                                <div class="input-group stylish-input-group" style="visibility: hidden;">
                                    <input type="text" class="form-control" placeholder="Job Search">
                                    <span class="input-group-addon">
                                            <button type="submit">
                                                <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
                                    </button>
                                    </span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="col-md-12"><h1 class="h1">Job / Events: {{job.title}}</h1></div>
                    <!-- <div class="col-md-12"><h1 class="page-disclaimer-header">Only confirmed Calls Are Displayed To Be Printed</h1></div> -->
                </div>

                <div class="row">
                    <div v-if="signInPageBrokenStatus" v-for="(callsByday, key, index) in signInSheetsData.calls" :key="key" class="col-lg-12 col-md-12 job-signin-table u-cmn-botmargin">
                        <div :class="{'page-break':index!=0}"></div>
                        <div class="u-bg-color-fff u-cmn-padding c-common-box-shadow c-radius3 u-relative">
                            <a href="javascript: void(0)" class="print-icon" @click="printThis($event)">
                                <i class="fa fa-print" aria-hidden="true"></i>
                            </a>
                            <div class="section-to-print">
                                <div class="row job-signin-table--header">
                                    <div class="col-sm-12 o-no-padding o-display-table">
                                        <div v-if="display_logo_header=='1'" class="col-md-2 col-sm-3 o-display-table-cell formSigninLogo">
                                            <img v-if="clientLogo != ''" :src="(clientLogo)" />
                                            <img v-if="clientLogo == ''" src="static/assets/images/logo.png" />
                                        </div>
                                        <div class="col-md-8 col-sm-6 text-left o-display-table-cell">
                                            
                                            <ul class="ps2">
                                                <li v-for="(job,jobIdx) in jobSigninDetails" :key="jobIdx" v-if="job.name != ''">
                                                <strong>{{job.name}}</strong>:
                                                <!-- {{(job.value !='empty_row') ? (job.name == 'Dates' ? convertToFormatDate(job.value) : job.value) : ''}}</li> -->
                                                <span class="inline-sibling-first" v-html="(job.value !='empty_row') ? (job.name == 'Dates' ? convertToFormatDate(job.value) : job.value) : ''"></span>
                                            </li>
                                            </ul>
                                        </div>
                                        <div class="col-md-2 col-sm-3 o-display-table-cell formSigninLogo">
                                            <img src="static/assets/images/logo.png">
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <hr class="o-modal-separetor" />
                                    </div>

                                    <div class="col-sm-12 o-no-padding">
                                        <div class="col-sm-9 ps1 u-cmn-botmargin">
                                            <strong>Day {{index+1}} - {{getDate(key)}}</strong>
                                        </div>
                                        <div class="col-sm-3 ps1 u-cmn-botmargin sign-sortby">
                                            <div class="form-group-right o-custom-dropdown">
                                                <select @change="sortSignInSheet(index)" v-model="selectedSortTypeByDay[index].sortType" class="form-control">
                                                    <option value="-1">Sort by</option>
                                                     <option v-for="(callHeader, index) in getSignInSheetConfig['call-data-config']" :key="index" :value="callHeader.value" v-if="callHeader.name !='Signature' && callHeader.name !=''">{{callHeader.name}}</option>
                                                </select>
                                                <span class="o-custom-drop-arrow o-custom-drop-arrow-top"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="table-responsive job-signin ps2 u-cmn-botmargin sign-in-sheet-overflow-y">
                                    <table class="table table-striped o-signin-sheet-table">
                                        <thead>
                                          <tr>
                                            <th>#</th>
                                            <th v-for="(callHeader,callHeaderIdx) in getSignInSheetConfig['call-data-config']" :key="callHeaderIdx" v-if="callHeader.name != ''">{{callHeader.name}}</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(call, indexs) in Object.values(callsByday)" :key="indexs">
                                            <td>{{parseInt(indexs) + 1}}</td>

                                            <columnDynamicData  v-for="(callHeader, key) in getSignInSheetConfig['call-data-config']" :label="callHeader.value" :item="call" :key="key" v-if="callHeader.name != ''"></columnDynamicData>
                                            
                                          </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="!signInPageBrokenStatus" class="col-lg-12 col-md-12 job-signin-table u-cmn-botmargin">
                        <div class="u-bg-color-fff u-cmn-padding c-common-box-shadow c-radius3 u-relative">
                            <a href="javascript: void(0)" class="print-icon" @click="printThis($event)">
                                <i class="fa fa-print" aria-hidden="true"></i>
                            </a>
                            <div class="section-to-print">
                                
                                <div class="row job-signin-table--header">
                                    <div class="col-sm-12 o-no-padding o-display-table">
                                        <div class="col-md-2 col-sm-3 o-display-table-cell formSigninLogo">
                                            <img v-if="clientLogo != ''" :src="(clientLogo)" />
                                            <img v-if="clientLogo == ''" src="static/assets/images/logo.png" />
                                        </div>
                                        <div class="col-md-8 col-sm-6 text-left o-display-table-cell">
                                            <ul class="ps2">
                                                <li v-for="(job,jobIndexs) in jobSigninDetails" :key="jobIndexs">
                                                    <strong>{{job.name}}</strong>
                                                    <!-- {{(job.value !='empty_row')?job.value : ''}} -->
                                                    <span class="inline-sibling-first" v-html="(job.value !='empty_row') ? (job.name == 'Dates' ? convertToFormatDate(job.value) : job.value) : ''"></span>
                                                </li>                                                
                                            </ul>
                                        </div>
                                        <div class="col-md-2 col-sm-3 o-display-table-cell formSigninLogo">
                                            <img src="static/assets/images/logo.png">
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                    <hr class="o-modal-separetor" />
                                </div>

                                    <!-- <div class="col-sm-12 o-no-padding">
                                        <div class="col-sm-12 ps2 u-cmn-botmargin">
                                            <strong>Comments</strong>Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                        </div>
                                    </div>   -->

                                </div>
                                <div v-if="!signInPageBrokenStatus" v-for="(callsByday, key, index) in signInSheetsData.calls" :key="key">
                                    <div class="row job-signin-table--header">
                                        <div class="col-sm-12 o-no-padding">
                                            <div class="col-sm-10 ps1 u-cmn-botmargin">
                                                <strong>Day {{index+1}} - {{getDate(key)}}</strong>
                                            </div>
                                            <div class="col-sm-2 ps1 u-cmn-botmargin sign-sortby">
                                                <div class="form-group-right o-custom-dropdown">
                                                    <select @change="sortSignInSheet(index)" v-model="selectedSortTypeByDay[index].sortType" class="form-control">
                                                        <option value="-1">Sort by</option>
                                                        <option v-for="(callHeader, index) in getSignInSheetConfig['call-data-config']" :key="index" :value="callHeader.value">{{callHeader.name}}</option>
                                                    </select>
                                                    <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                </div>
                                            </div>
                                        </div>   
                                    </div>
                                    <div class="table-responsive job-signin ps2 u-cmn-botmargin sign-in-sheet-overflow-y">
                                        <table class="table table-striped o-signin-sheet-table">
                                            <thead>
                                              <tr>
                                                <th>#</th>
                                                <th v-for="(callHeader,indexCallHeader) in getSignInSheetConfig['call-data-config']" :key="indexCallHeader" v-if="callHeader.name != ''">{{callHeader.name}}</th>
                                               
                                              </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(call,indexCall) in callsByday" :key="indexCall">
                                                    <td>1</td>
                                                    <!-- <columnDynamic v-for="(item, index) in call" :item="item" :key="index"></columnDynamic> -->
                                                    <columnDynamicData  v-for="(callHeader, key) in getSignInSheetConfig['call-data-config']" :label="callHeader.value" :item="call" :key="key" v-if="callHeader.name != ''"></columnDynamicData>              
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                               <!--  <div class="row text-center">
                                    <div class="col-md-12 o-signin-logo">
                                        <img src="static/assets/images/callsteward-old-img.png">
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>

                    <div v-loading="loading" v-if="signInSheetsData.length == 0 ? true : signInSheetsData.calls.length == 0" class="c-common-space c-common-gradient c-common-box-shadow c-radius3 side-padding">
                        <div class="col-md-12 no-job-dispaly">
                           <i class="fa fa-frown-o" aria-hidden="true"></i>
                           <br />
                            No Calls Added
                        </div>
                    </div>  
                </div>

            </div>
            <!-- c-responsive-fixwidth -->
        </div>
        <!-- /Main Body Content area -->
  </div>
</template>
<script>
    import dateTimeConvert from '../../../timeConvert&Compare';
    import {VueEditor} from 'vue2-editor';
    import service from '../../../services.js';
    import {mapGetters, mapActions} from 'vuex';
    import {global} from '../../../global.js';
    import columnDynamicData from './columnDynamicData';
    export default {
        components: {
            VueEditor,
            'columnDynamicData':columnDynamicData,
        },
        data() {
            return {
                signInSheetsData: [],
                jobSigninDetails: [],
                callSigninDetails: [],
                selectedSortTypeByDay: [],
                job: [],
                getBaseURL: '',
                clientLogo: '',
                sort_call_configuration:{
                    primary:'',
                    secondary:'',
                    ternary:'',
                },
                getSignInSheetConfig: {
                    'sign-in-sheet': [],
                    'call-data-config': [],
                    'job-info-config': [],
                },
                signInPageBrokenStatus:0,
                userClientID:'',
                display_logo_header:1,
                loading:true
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                companyId: 'companyId',
                // userClientID: 'userClientID',
                // signInSheetConfig
                // getSignInSheetConfig: 'getSignInSheetConfig',
                // signInPageBrokenStatus: 'signInPageBrokenStatus',
            })
        },
        mounted() {

        },
        methods: {
            // sortSignInSheet(index) {
            //     let curOpt = this.selectedSortTypeByDay[index].sortType;
            //     let curPos = Object.keys(this.signInSheetsData.calls)[index];
            //     let curObj = Object.values(this.signInSheetsData.calls[curPos]);
            //     // console.log('curOpt',curOpt, this.selectedSortTypeByDay);
            //     // console.log('curPos',curPos, this.signInSheetsData.calls);
            //     // console.log('curObj',curObj, index);

            //     //2nd Sort
            //     let curOpt2 = this.getSignInSheetConfig['call-data-config'].findIndex(item => item.value === this.sort_call_configuration.secondary);

            //     //3nd Sort
            //     let curOpt3 = this.getSignInSheetConfig['call-data-config'].findIndex(item => item.value === this.sort_call_configuration.ternary);

            //     console.log(curOpt, curOpt2, curOpt3);

            //     if (curObj.length > 1) {
            //         this.signInSheetsData.calls[curPos] = curObj.sort(function(a, b) {
            //             if (a[curOpt].value < b[curOpt].value) return -1;
            //             if (a[curOpt].value > b[curOpt].value) return 1;
            //             if (curOpt2 !=-1) {
            //                 if (a[curOpt2].value < b[curOpt2].value) return -1;
            //                 if (a[curOpt2].value > b[curOpt2].value) return 1;
            //             }
            //             if (curOpt3 !=-1) {
            //                 if (a[curOpt3].value < b[curOpt3].value) return -1;
            //                 if (a[curOpt3].value > b[curOpt3].value) return 1;
            //             }
            //             return 0;
            //         });
            //     }
            // },
            sortSignInSheet(index){
                let type = this.selectedSortTypeByDay[index].sortType;
                let callDay = Object.keys(this.signInSheetsData.calls)[index];
                // console.log(type,callDay,this.signInSheetsData.calls[callDay]);

                //2nd Sort exist
                let type2Exist = this.getSignInSheetConfig['call-data-config'].findIndex(item => item.value === this.sort_call_configuration.secondary);
                let type2=this.sort_call_configuration.secondary;

                //3nd Sort exist
                let type3Exist = this.getSignInSheetConfig['call-data-config'].findIndex(item => item.value === this.sort_call_configuration.ternary);
                let type3=this.sort_call_configuration.ternary;

                let sortObj = Object.values(this.signInSheetsData.calls[callDay]);
                // console.log(type,type2,type3);

                switch(type){
                    case 'skill_id':
                        console.log('skill_id');
                        this.signInSheetsData.calls[callDay]= sortObj.sort(function(a, b){
                            // console.log(a,b);
                            if(a.skill_priority < b.skill_priority) return -1;
                            if(a.skill_priority > b.skill_priority) return 1;
                            if (type2Exist !=-1) {
                                if(a.type2 < b.type2) return -1;
                                if(a.type2 > b.type2) return 1;
                            }
                            if (type3Exist !=-1) {
                                if(a.type3 < b.type3) return -1;
                                if(a.type3 > b.type3) return 1;
                            }
                            return 0;
                        });
                        break;
                    case 'employee_lf':
                        this.signInSheetsData.calls[callDay]= sortObj.sort(function(a, b){
                            // console.log(a,b);
                            if(a.last_name < b.last_name) return -1;
                            if(a.last_name > b.last_name) return 1;
                            if (type2Exist !=-1) {
                                if(a.type2 < b.type2) return -1;
                                if(a.type2 > b.type2) return 1;
                            }
                            if (type3Exist !=-1) {
                                if(a.type3 < b.type3) return -1;
                                if(a.type3 > b.type3) return 1;
                            }
                            return 0;
                        });
                        break;
                    case 'employee_fl':
                        this.signInSheetsData.calls[callDay]= sortObj.sort(function(a, b){
                            // console.log(a,b);
                            if(a.first_name < b.first_name) return -1;
                            if(a.first_name > b.first_name) return 1;
                            if (type2Exist !=-1) {
                                if(a.type2 < b.type2) return -1;
                                if(a.type2 > b.type2) return 1;
                            }
                            if (type3Exist !=-1) {
                                if(a.type3 < b.type3) return -1;
                                if(a.type3 > b.type3) return 1;
                            }
                            return 0;
                        });
                        break;
                    case 'seniority':
                        this.signInSheetsData.calls[callDay]= sortObj.sort(function(a, b){
                            // console.log(a,b);
                            if(a.seniority < b.seniority) return -1;
                            if(a.seniority > b.seniority) return 1;
                            if (type2Exist !=-1) {
                                if(a.type2 < b.type2) return -1;
                                if(a.type2 > b.type2) return 1;
                            }
                            if (type3Exist !=-1) {
                                if(a.type3 < b.type3) return -1;
                                if(a.type3 > b.type3) return 1;
                            }
                            return 0;
                        });
                        break;
                    case 'start':
                        this.signInSheetsData.calls[callDay]= sortObj.sort(function(a, b){
                            // console.log(a,b);
                            if(a.call_start < b.call_start) return -1;
                            if(a.call_start > b.call_start) return 1;
                            if (type2Exist !=-1) {
                                if(a.type2 < b.type2) return -1;
                                if(a.type2 > b.type2) return 1;
                            }
                            if (type3Exist !=-1) {
                                if(a.type3 < b.type3) return -1;
                                if(a.type3 > b.type3) return 1;
                            }
                            return 0;
                        });
                        break;
                    case 'end':
                        this.signInSheetsData.calls[callDay]= sortObj.sort(function(a, b){
                            // console.log(a,b);
                            if(a.call_end < b.call_end) return -1;
                            if(a.call_end > b.call_end) return 1;
                            if (type2Exist !=-1) {
                                if(a.type2 < b.type2) return -1;
                                if(a.type2 > b.type2) return 1;
                            }
                            if (type3Exist !=-1) {
                                if(a.type3 < b.type3) return -1;
                                if(a.type3 > b.type3) return 1;
                            }
                            return 0;
                        });
                        break;
                    case 'total_shifts':
                        this.signInSheetsData.calls[callDay]= sortObj.sort(function(a, b){
                            // console.log(a,b);
                            if(a.total_shifts < b.total_shifts) return -1;
                            if(a.total_shifts > b.total_shifts) return 1;
                            if (type2Exist !=-1) {
                                if(a.type2 < b.type2) return -1;
                                if(a.type2 > b.type2) return 1;
                            }
                            if (type3Exist !=-1) {
                                if(a.type3 < b.type3) return -1;
                                if(a.type3 > b.type3) return 1;
                            }
                            return 0;
                        });
                        break;
                    case 'employee_phone':
                        this.signInSheetsData.calls[callDay]= sortObj.sort(function(a, b){
                            // console.log(a,b);
                            if(a.phone_number < b.phone_number) return -1;
                            if(a.phone_number > b.phone_number) return 1;
                            if (type2Exist !=-1) {
                                if(a.type2 < b.type2) return -1;
                                if(a.type2 > b.type2) return 1;
                            }
                            if (type3Exist !=-1) {
                                if(a.type3 < b.type3) return -1;
                                if(a.type3 > b.type3) return 1;
                            }
                            return 0;
                        });
                        break;
                    case 'confirmed':
                        this.signInSheetsData.calls[callDay]= sortObj.sort(function(a, b){
                            // console.log(a,b);
                            if(a.confirm_by < b.confirm_by) return -1;
                            if(a.confirm_by > b.confirm_by) return 1;
                            if (type2Exist !=-1) {
                                if(a.type2 < b.type2) return -1;
                                if(a.type2 > b.type2) return 1;
                            }
                            if (type3Exist !=-1) {
                                if(a.type3 < b.type3) return -1;
                                if(a.type3 > b.type3) return 1;
                            }
                            return 0;
                        });
                        break;
                    case 'status_id':
                        this.signInSheetsData.calls[callDay]= sortObj.sort(function(a, b){
                            // console.log(a,b);
                            if(a.status_name < b.status_name) return -1;
                            if(a.status_name > b.status_name) return 1;
                            if (type2Exist !=-1) {
                                if(a.type2 < b.type2) return -1;
                                if(a.type2 > b.type2) return 1;
                            }
                            if (type3Exist !=-1) {
                                if(a.type3 < b.type3) return -1;
                                if(a.type3 > b.type3) return 1;
                            }
                            return 0;
                        });
                        break;
                }
            },
            getFieldValue(value) {
                return (value != 'empty') ? (moment(value, "YYYY-MM-DD HH:mm:ss", true).isValid() ? this.getTime(value) : (value=='underline'?'_____________________':value)) : '';
            },
            getTime(dateTime) {
                return dateTimeConvert.globalTime(dateTime);
                //return time;
            },
            getDate(dateTime) {
                return dateTimeConvert.extractDateOnly(dateTime);
            },
            convertToFormatDate(dateTime) {
                var dates = dateTime.split('@#@');
                return this.getDate(dates[0]) + ' to ' + this.getDate(dates[1]);
            },
            backTojobDetails() {
                this.$router.push({
                    path: `/employerJobDetails/` + this.$route.params.jobId
                });
            },
            getSignInData() {
                this.$Progress.start();
                this.loading=true;
                service.get('call/signInSheets', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'job-id': atob(this.$route.params.jobId)
                }).
                then((res) => {
                    this.loading=false;
                    //console.log(res);
                    this.signInSheetsData = res.data.result;
                    this.$Progress.finish();
                    let curOpt = this.getSignInSheetConfig['call-data-config'].findIndex(item => item.value === this.sort_call_configuration.primary);
                    //console.log("API Data", this.signInSheetsData);
                    this.jobSigninDetails = this.signInSheetsData.job;
                    for (let key in this.signInSheetsData.calls) {
                        let tempData = {
                            'sortType': (curOpt == -1)?curOpt:this.sort_call_configuration.primary,
                            'date': key,
                        };
                        //console.log(tempData);
                        this.selectedSortTypeByDay.push(tempData);
                    }
                    let i=0;
                    for(let key in this.signInSheetsData.calls){
                        this.sortSignInSheet(i);
                        i++;
                    }
                    setTimeout(()=>{
                        $(".inline-sibling-first").children().css({"display": "inline"});  
                    },2000);
                }).catch((err) => {
                    console.log(err);
                    this.loading=false;
                });
            },
            printThis(e) {
                e.preventDefault();
                // $('.job-signin-table').hide();
                // $(e.target).parents('.job-signin-table').show();
                window.print();
            },
            jobDetails() {
                this.loading=true;
                this.$Progress.start();
                service.get('employerjob/'+atob(this.$route.params.jobId), {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'employer-id': this.companyId,
                }).then((res) => {
                    //console.log("Job details", res);
                    this.loading=false;
                    this.job = res.data.result;
                    this.getSignInSheetConfig = {
                        'sign-in-sheet': this.job.client.settings['sign-in-sheet'],
                        'call-data-config': this.job.client.settings['call-data-config'],
                        'job-info-config': this.job.client.settings['job-info-config'],
                    };
                    this.signInPageBrokenStatus=this.job.client.page_breakdown;
                    this.clientLogo=this.job.client.logo;
                    this.userClientID=this.job.client.id;

                    this.sort_call_configuration=JSON.parse(this.job.client.sort_call_configuration);
                    this.display_logo_header=this.job.client.display_logo_header;
                    //this.getClient(clientId);
                    this.getSignInData();
                }).catch((err) => {
                    console.log(err);
                    this.loading=false;
                });
            },
        },
        beforeMount() {
            window.onafterprint = function() {
                $('.job-signin-table').show();
            };
        },
        created() {
            this.getBaseURL = global[0].IMAGE_URL;
            this.jobDetails();
            //console.log("config Data", atob(this.$route.params.jobId));
        },
        mounted(){
            $("#fc_frame").css('display', 'none');
        },
        beforeDestroy(){
            $("#fc_frame").css('display', 'block');
        },
    }

</script>
<style scoped>

.page-disclaimer-header {
    font-weight: 500;
    text-align: -webkit-center;
    padding-bottom: 8px;
}
.job-signin { height: auto; }
.table>thead>tr>th {
    background: #b6b2b2 !important;
}
@media all {
	.page-break	{ display: none; }
}

@media print {
	.page-break	{ display: block; page-break-before: always; }
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/signInSheet/employerSignInSheet.vue